import { groupBy } from "lodash-es";
import formatter from "../../utils/formatters/formatter";
import { format } from "date-fns";

// if you want to add logout and query timeout events you need also to update subtitles and mapping functions
export const events = [
  { key: "login", label: "Login" },
  { key: "page.view", label: "Page View" },
  // { key: "logout", label: "Logout" },
  // { key: "query.timeout", label: "Query Timeout" },
];

export const chart = {
  overrides: [
    {
      name: "io_user_uuid",
    },
    {
      name: "io_created_at",
    },
    {
      name: "io_created_at",
      aggregation: "MONTH",
    },
    {
      name: "event",
    },
    {
      name: "io_relevant_id",
    },
  ],
  orders: [
    {
      name: "io_created_at",
      sort: "DESC",
    },
  ],
  allDates: true,
  filters: [{ type: "user_name", operator: "!=", value: null }],
  type: "TableChart",
  subTitles: [["User", "Date", "Login", "Page View"]],
  freezeLeft: true,
  freezeWidth: 400,
  textAlignOverride: {
    Login: "right",
    "Page View": "right",
  },
  rawRows: true,
  generalColumnsWidth: 200,
  showSearch: true,
  hasRowExpand: true,
  rowExpandVisualizationParams: {
    showSearch: false,
    id: "row-expand-d8e0e7fe-bbe0-446e-abe1-a3cb60d95bd3",
    visualizationId: "row-visualization-d8e0e7fe-bbe0-446e-abe1-a3cb60d95bd3",
    overflowX: "unset",
    hasRowExpand: false,
    stickyHeaders: false,
    overrides: [
      {
        name: "io_user_uuid",
      },
      {
        name: "io_created_at",
      },
      {
        name: "event",
      },
      {
        name: "io_relevant_id",
      },
    ],
    dynamicFilters: ["io_user_uuid", "io_created_at"],
    dynamicFilterValue: { io_created_at: "Monthio_created_at" },
    usage: true,
    ignorePagination: false,
    rawRows: true,
  },
  convertGetToPost: true,
  id: "ch-0002V",
  ignorePagination: true,
  usage: true,
  visualizationId: "3d5f166a-1a7a-45bf-939f-4665b0da56df",
  hideDetailLink: true,
};

export function getMappedSummaryData(data) {
  const dataWithUsers = (data ?? []).filter((row) => row.user_name !== null);

  // Group the input data by a composite key of Monthio_created_at and io_user_uuid
  const groupedData = groupBy(
    dataWithUsers,
    (row) => `${row.Monthio_created_at}::${row.io_user_uuid}`
  );

  // Convert the grouped entries into an array of transformed objects
  return Object.entries(groupedData).map(([compositeKey, entries]) => {
    // Destructure the composite key into date and user ID
    const [createdAt, userUuid] = compositeKey.split("::");

    // Get the user's name using the user ID
    const userName = getUserNameFromArray(userUuid, entries);

    // Format the date for display
    const formattedDate = formatter(createdAt, "MMMM yyyy");

    // Return the final object with user, date, and event counts merged together
    return {
      io_user_uuid: userUuid, // original user ID
      Monthio_created_at: createdAt, // original raw date
      User: userName, // resolved user name
      Date: formattedDate, // formatted date string
      ...getEventCounts(entries), // dynamically added event count fields
    };
  });
}

export function getMappedDrilldownData(data) {
  return data.map((row) => ({
    User: getUserNameFromRow(row),
    Date: format(row.io_created_at, "MMMM dd, yyyy hh:mm:ss aaa"),
    Login: row.event === "login" ? "Success" : null,
    "Page View": row.page_display_name,
  }));
}

function getUserNameFromRow(row) {
  const name = row?.user_name ?? "";
  const email = row?.user_email ?? "";
  return `${name} (${email})`;
}

function getUserNameFromArray(uuid, data) {
  const row = (data ?? []).find((item) => item.io_user_uuid === uuid);
  return getUserNameFromRow(row);
}

function getEventCounts(entries) {
  // Reduce the events to build a map of event label -> count for this group
  return events.reduce((acc, event) => {
    // Count how many rows in the group match the current event key
    const count = entries.filter(
      ({ event: rowEvent }) => rowEvent === event.key
    ).length;

    acc[event.label] = count || null;
    return acc;
  }, {});
}
